// Messages for portal/AcceptInvitation (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'portal.accept_invitation.invalid_head': 'Invitation — Customer portal',
  'portal.accept_invitation.invalid_title': 'Invitation not valid',
  'portal.accept_invitation.invalid_body':
    'This invitation link is invalid, has expired, or has already been used. Ask your company administrator to re-send it.',
  'portal.accept_invitation.head': 'Accept invitation — Customer portal',
  'portal.accept_invitation.title': 'Set your password',
  'portal.accept_invitation.activating': 'Activating {email}',
  'portal.accept_invitation.password_label': 'Choose a password (at least 12 characters)',
  'portal.accept_invitation.password_error': 'Password {error}',
  'portal.accept_invitation.submit': 'Activate account',
}

export const zhTW = {
  'portal.accept_invitation.invalid_head': '邀請 — 客戶入口',
  'portal.accept_invitation.invalid_title': '邀請無效',
  'portal.accept_invitation.invalid_body':
    '此邀請連結無效、已過期或已被使用。請聯絡貴公司管理員重新傳送。',
  'portal.accept_invitation.head': '接受邀請 — 客戶入口',
  'portal.accept_invitation.title': '設定您的密碼',
  'portal.accept_invitation.activating': '正在啟用 {email}',
  'portal.accept_invitation.password_label': '選擇密碼（至少 12 個字元）',
  'portal.accept_invitation.password_error': '密碼 {error}',
  'portal.accept_invitation.submit': '啟用帳戶',
}
